import { useAppSelector } from "@/redux/hooks";
import { authSelectors } from "@/redux/slices/auth.slice";

/**
 * Hook para verificar se o usuário tem permissão para funcionalidades administrativas de ensino
 * (acessar tela financeira, gerenciar cursos, etc.)
 * @returns {boolean} - true se o usuário é master ou tem permissão ENSINO
 */
export function useEnsinoPermission(): boolean {
  const user = useAppSelector((state) => state.authReducer);
  const isEnsinoAdm = useAppSelector(authSelectors.isEnsinoAdm);

  // Se não há usuário, não tem permissão
  if (!user) {
    return false;
  }

  // Usuários master sempre têm permissão
  if (user.Master) {
    return true;
  }

  // Verificar se o usuário tem permissão específica para ENSINO via selector
  return isEnsinoAdm || false;
}
